import type { GameKey } from '@hazel/shared'

import type { Track } from './cues.js'

/**
 * Which tune each game plays.
 *
 * A `Record` over `GameKey`, so a game added to the roster does not compile
 * until somebody has said what it sounds like — the same gate `HOW_TO_START`
 * and `SKILLS_BY_GAME` put in front of their own decisions.
 *
 * **It is not always the game's own name**, which is the whole reason it is
 * written down. Maritza's Mosaic borrows Stripey's loop: both are quiet
 * sit-down puzzles, the track suits either, and sharing one beats shipping a
 * game in silence. Until this existed that borrowing was a literal inside a
 * component, and the browser test that checks each screen asks for its tune
 * had no way to know — it assumed the route named the track, which was true
 * of eight games and then was not.
 *
 * The day there is a `mosaic.mp3`, this is the one line that changes.
 */
export const TRACK_FOR_GAME: Readonly<Record<GameKey, Track>> = {
  hangman: 'hangman',
  maths: 'maths',
  memory: 'memory',
  trolley: 'trolley',
  scramble: 'scramble',
  riddles: 'riddles',
  sudoku: 'sudoku',
  mosaic: 'sudoku',
  // Stripey's loop again: three quiet sit-down puzzles, one track that suits
  // any of them. A `mastermind` file is one line here the day there is one.
  mastermind: 'sudoku',
}

/*
 * Its own file, away from `cues.ts`.
 *
 * `cues.ts` asks the bundler for the files it has with `import.meta.glob`,
 * which only exists inside Vite — so importing it from a Playwright test,
 * which runs in plain Node, fails at the glob before it reaches this table.
 * The table is the one part of the sound wiring something outside the browser
 * needs to read, so it lives where it can be read.
 */
